exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share ul {\r\n        list-style-type: none;\r\n        margin: 0;\r\n        padding: 0;\r\n        text-align: center;\r\n    }\r\n\r\n        .share ul li {\r\n            display: inline;\r\n            padding: 10px;\r\n        }\r\n\r\n\r\n        .head_li li a {\r\n                color: #000 !important;\r\n            }\r\n\r\n            #navigation {\r\n                background-color: rgb(255, 192, 0) !important;\r\n            }\r\n\r\n            .ancer {\r\n                color: #000 !important;\r\n            }\r\n.center {\r\n  text-align:center;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/team/team.component.css
// module id = ../../../../../src/app/team/team.component.css
// module chunks = 2